import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

type TimeFieldProps = {
  label: string;
  valueStr?: string | null;
  onChange(time: string | null): void;

  size?: 'small' | 'medium';
  margin?: 'none' | 'dense' | 'normal';

  textFieldProps?: Partial<TimeFieldProps>;
};

// Base date for parsing time-only values
const BASE_DATE = '1970-01-01T';

const TimeField: React.FC<TimeFieldProps> = React.memo(
  ({ label, valueStr, onChange, size = 'small', margin = 'none' }) => {
    const dateValue = valueStr ? new Date(`${BASE_DATE}${valueStr}`) : null;

    return (
      <TimePicker
        label={label}
        value={dateValue}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '14px',
          }
        }}
        onChange={newVal => {
          if (newVal) {
            const h = newVal.getHours().toString().padStart(2, '0');
            const m = newVal.getMinutes().toString().padStart(2, '0');
            onChange(`${h}:${m}`);
          } else {
            onChange(null);
          }
        }}
        views={['hours', 'minutes']}
        slotProps={{
          textField: {
            fullWidth: true,
            size,
            margin,
            InputLabelProps: { shrink: true },
          },
          openPickerButton: {
            sx: {
              '& .MuiSvgIcon-root': { fontSize: 20 },
            },
          },
          inputAdornment: {
            sx: {
              '& .MuiIconButton-root .MuiSvgIcon-root': { fontSize: 20 },
            },
          },
          popper: {
            sx: {
              '& .MuiClockNumber-root': { fontSize: '20px' },
            },
          },
        }}
      />
    );
  }
);

export default TimeField;
